const ACTIVE_CATEGORY_SET = 'ACTIVE_CATEGORY_SET';
const ACTIVE_CATEGORY_CHANGED = 'ACTIVE_CATEGORY_CHANGED';

const setActiveCategory = (category) => ({
  type: ACTIVE_CATEGORY_SET,
  category
});

const changeActiveCategory = (category) => ({
  type: ACTIVE_CATEGORY_CHANGED,
  category
});

export {
  ACTIVE_CATEGORY_CHANGED,
  ACTIVE_CATEGORY_SET,
  changeActiveCategory,
  setActiveCategory,
};



// WEBPACK FOOTER //
// ./src/redux/actions/categories.js